import * as R from 'ramda';

const addPlacement = store => async (state, { rhId, placement }) => {
    const userClientId = state.user.selectedUserClientId;
    const rightsholders =
        state.clients[userClientId].settings.client.onboarding.rightsholders;
    const rhIndex = rightsholders.findIndex(rh => rh.id === rhId);
    const placements =
        rightsholders[rhIndex].placements.length > 0
            ? [...rightsholders[rhIndex].placements, placement]
            : [placement];

    const placementLens = R.lensPath([
        'clients',
        userClientId,
        'settings',
        'client',
        'onboarding',
        'rightsholders',
        rhIndex,
        'placements',
    ]);

    store.setState(R.set(placementLens, placements, store.getState()), true);
};

export default addPlacement;
